<div class="moduleContainer" *ngIf="translations">
  <br />
  <div class="infoCustomer" *ngIf="show.customerInfo">
    <h2>{{surname}} {{name}} - {{card_no}}</h2>
  </div>
  <br />
  <br />
  <div class="" *ngIf="!currentExistingFiles || (currentExistingFiles.length && currentExistingFiles.length == 0)"><p>{{'upload.no_invoices_uploaded' | translate}}</p></div>
  <div class="" *ngFor="let file of currentExistingFiles;let i=index;">
    <div class="" *ngIf="file.exist">
      <p-button pTooltip="{{'upload.download_invoice_file' | translate}}" label="" icon="fa fas fa-file" styleClass="ui-button-info" (onClick)="onClickShowFile(file)"></p-button>
      &nbsp;{{file.date | date: 'dd/MM/yyyy'}} - {{file.originalFileName}}
      <br />
      <br />
    </div>
  </div>
  <div class="" *ngIf="currentExistingFiles.length == 0">{{'upload.no_invoices_uploaded' | translate}}</div>
  <div *ngIf="show.upload && show.available">
    <br />
    <br />
    <div class="uploadMoule">
      <p>{{'upload.upload_file_info' | translate}}</p>
      <p-fileUpload #upload data-testid="upload" name="upload" customUpload="true" [chooseLabel]="translations['upload.choose_file']" [multiple]="false" auto="true" (uploadHandler)="onFileUpload($event, upload)" (onRemove)="onClearUpload()"></p-fileUpload>
    </div>
    <br />
    <br />
    <div class="" *ngIf="file">
      <button pButton class="k-generic-btn" (click)="onClickSave()" type="button" icon="fa fa-floppy-o" iconPos="left" label="{{'common.save' | translate}}" ></button>
    </div>
  </div>
</div>



// WEBPACK FOOTER //
// ./src/app/views/customerDB/customers/upload-mg-fatture-premi/uploadmgfatturepremi.component.html